import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  currentYear
  constructor(private router: Router) { }

  ngOnInit() {
    this.currentYear = new Date();
  }
  footerClick(selectedMenu) {
    const scrollInitial = document.getElementsByTagName('html');
    scrollInitial[0].classList.add('letsgo');
    if (selectedMenu === 'faq') {
      this.router.navigateByUrl('/faq');
    } else if (selectedMenu === 'precontact') {
      this.router.navigateByUrl('/faq/contact-us');
    } else if (selectedMenu === 'privacypolicy') {
      this.router.navigateByUrl('/faq/privacy-policy');
    } else if (selectedMenu === 'termsofservice') {
      this.router.navigateByUrl('/faq/terms-of-service');
    } else if (selectedMenu === 'residential') {
      this.router.navigateByUrl('/');
    }  else if (selectedMenu === 'giveback') {
      this.router.navigateByUrl('/giveback');
    } else if (selectedMenu === 'precontactmob') {
      this.router.navigateByUrl('/pre-contact');
    } else if (selectedMenu === 'privacypolicymob') {
      this.router.navigateByUrl('/privacy-policy');
    }  else if (selectedMenu === 'termsofservicemob') {
      this.router.navigateByUrl('/terms-of-service');
    } else if (selectedMenu === 'commercial') {
      this.router.navigateByUrl('/commercial');
    } else if (selectedMenu === 'blog') {
      this.router.navigateByUrl('/blog');
    }
  }
}
